import Alert from "@pathwright/ui/src/components/alert/Alert"
import Avatar from "@pathwright/ui/src/components/avatar/Avatar"
import BlankSlate from "@pathwright/ui/src/components/blank/BlankSlate"
import SubmitButton from "@pathwright/ui/src/components/button/SubmitButton"
import RichTextInput from "@pathwright/ui/src/components/form/form-richtext/RichTextInput"
import { ConnectForm } from "lib/core/components/forms"
import debounce from "lodash/debounce"
import { useEffect, useRef, useState } from "react"
import "./MessageForm.css"
import MessageTo from "./MessageTo"

function stripHtml(html) {
  var tmp = document.createElement("div")
  tmp.innerHTML = html
  return tmp.textContent || tmp.innerText || ""
}

const fieldsData = {
  message: {
    placeholder: "Write a message...",
    optional: true,
    inline: true
  }
}

const MessageForm = (props) => {
  const {
    user,
    context,
    send_error,
    isValid,
    isPristine,
    fieldsData,
    handleSubmit
  } = props

  const [hasText, setHasText] = useState(false)
  // verify the editor contains text in order to enable submit button
  const debouncedSetHasText = useRef(
    debounce((value, currentvHasText) => {
      const textValue = stripHtml(value)
      if (!!textValue !== currentvHasText) {
        setHasText(!currentvHasText)
      }
    }, 500)
  ).current

  useEffect(() => {
    debouncedSetHasText(fieldsData.message.value, hasText)
  }, [fieldsData.message.value])

  return context && context.user_count <= 0 ? (
    <BlankSlate
      heading="There's no one here yet."
      body="This is where you'll message your learners."
    />
  ) : (
    <form className="MessageForm" onSubmit={handleSubmit}>
      <div className="MessageForm__to">
        <MessageTo />
      </div>

      <div className="MessageForm__body">
        <Avatar user={user} size="30px" />
        <RichTextInput {...fieldsData.message} />
        {/* <DraftText {...fieldsData.message} /> */}
      </div>

      <div className="MessageForm__footer">
        <SubmitButton {...props} disabled={!hasText} styleType="primary">
          Send
        </SubmitButton>
        {context ? (
          context.user_count > 1 ? (
            <p>Delivered as a separate email to each person.</p>
          ) : (
            <p>Delivered as an email.</p>
          )
        ) : null}
      </div>
      {send_error && <Alert error={send_error} showClear={false} />}
    </form>
  )
}

MessageForm.displayName = "MessageForm"

export default ConnectForm(MessageForm, fieldsData)
